export enum DemandSendToSupplierStatus {
    UNWANTED = 'UNWANTED',
    UNSENT = 'UNSENT',
}
